module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/button-star-hover.fc7a629c.svg";